  <div>
    <div class="w-42 h-[80vh] rounded-l-none bg-white rounded-xl border-2 border-dnv-primary">
      <div class="flex flex-col py-8">
        <button
          class="px-2 py-1 text-start text-sm text-dnv-secondary flex flex-row cursor-pointer hover:bg-dnv-secondary/10"
          matFab extended
          (click)="onNavigate('/' + PNS_LIST_ROUTE)">
          <mat-icon class="text-dnv-secondary" fontIcon="query_stats"></mat-icon>
            <p class="px-2 py-1 text-black">Analisi</p>
        </button>
      </div>
    </div>
  </div>
